import React from 'react';
import { useSelector } from 'react-redux';
import loadable from '@loadable/component';
import cx from 'classnames';

import { isMobileSelector } from '../../selector/device';

const HeaderMobile = loadable(() => import('./HeaderMobile'));
const HeaderDesktop = loadable(() => import('./HeaderDesktop'));

function Header(props) {
  const isMobile = useSelector(isMobileSelector);

  return (
    <header
      className={cx('bg-brand-white border-b border-brand-grey-100', props.className)}
      style={{ height: 'var(--header-height)', ...props.style }}
    >
      {isMobile ? <HeaderMobile /> : <HeaderDesktop />}
    </header>
  );
}

export default Header;
